define([
    'base/utils/cookie',
    'base/utils/iamHttpService',
    'base/utils/utility'
], function (cookieOp, iamHttpService, utils) {
    'use strict';
    var i18n, iamUtils;

    function ResetPwd($scope, securityPolicy, _i18n, _iamUtils) {
        i18n = _i18n;
        iamUtils = _iamUtils;

        $scope.i18n = i18n;
        $scope.model = {
            currentLanguage: window.language,
            width: '315px',
            msgCodeWidth: iamUtils.layout.inputFiledWidthHalf,
            height: iamUtils.layout.inputFieldHeight,
            type: 'password',
            newPwdType: 'password',
            confirmPwdType: 'password',
            pwdVisible_1: false,
            pwdVisible_2: false,
            showConfirmPasswordCheck: false,
            submitType: 'major',
            focused: true,
            validTip: require('custom/images/default.png'),
            validSuc: require('custom/images/right.png'),
            validFail: require('custom/images/wrong.png'),
            tipPosition:'top',
            isFormShow:false,
            oldPasswordId: 'oldPasswordId',
            passwordId: 'passwordId',
            confirmPasswordId: 'confirmPasswordId',
            lowPasswords:[],
            msgCodeId: 'msgCodeId',
            msgBtnTxt: i18n('resetPwd.getSmsMsgCode'),
            msgCodeBtnId: 'msgCodeBtnId',
            msgBtnDisable: false,
            containsChars: i18n('passwordChars'),
            contSameCharLen:0,
            homepageUrl: iamUtils.CONFIG.homepageUrl,
            verifyTypeValue: '',
            phone: '',
            email: '',
            verifyTypeLabel: '',
            verifyTypeBtn: '',
            passwdErr:'None',
            msgCodeLabel: '',
            verifyType: '',
            loginUrl: '/authui/login.action?locale=' + window.language,
            verifyCodeMsg:'',
            emailMsgCodeBtnHandler: '',
            passwordFocused: false,
            smsMsgCodeBtnHandler: '',
            isLogout: true,
            password:'',
            oldPasswdLabel: i18n('resetPwd.oldPasswd'),
            isFirstLogin: false,
            maxPwdLength: securityPolicy.passwordpolicy.password_maxlen
        };

        initPage();

        getPasswordPolicy($scope, iamHttpService, securityPolicy);
        
        $scope.model.onUserClickSomeBox = function(){
            $('#errorMsg').html('');
            setClearTag();
        };

        $scope.model.onPasswordChange = function(){
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            if ($scope.model.lowPasswords.indexOf($scope.model.password) > -1) {
                $scope.model.isWeakPassword = true;
            } else {
                $scope.model.isWeakPassword = false;    
            }
            $scope.model.confirmPassword = '';
            $scope.model.showPasswordCheck = false;
            $scope.model.showConfirmPasswordCheck = false; //改动新密码后重置确认密码状态
            $scope.model.onUserClickSomeBox();
            pwdObj.removeClass('valid_error_input');
            utils.removeErrorInfo('#passwordError');
            showTip($scope);
            if(checkSame(pwdObj)){
                return;
            }
        };
        
        $scope.model.onConfirmPasswordChange = function (event, value) {
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            //显示确认密码成功提示条件：不为空、新密码合法、相等
            if ($scope.model.confirmPassword &&
                !pwdObj.hasClass('valid_error_input') &&
                $scope.model.confirmPassword === $scope.model.password
            ) {
                $scope.model.showConfirmPasswordCheck = true;
            } else {
                $scope.model.showConfirmPasswordCheck = false;
            }
        };

        // 密码显示和隐藏切换
        $scope.model.pwdVisibleFunc = function(index) {
            var type, pwdObj;
            if (index == 1) {
                type = $scope.model.pwdVisible_1 ? 'password' : 'text';
                $scope.model.pwdVisible_1 = !$scope.model.pwdVisible_1;
                $('#passwordId>input').attr('type', type);
            } else if(index == 2) {
                type = $scope.model.pwdVisible_2 ? 'password' : 'text';
                $scope.model.pwdVisible_2 = !$scope.model.pwdVisible_2;
                $('#confirmPasswordId>input').attr('type', type);
            }
            $scope.$apply();
        };

        $scope.model.onPasswordFocus = function() {
            showTip($scope);
        };
        $scope.model.oldPasswordBlur = function(){
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            checkSame(pwdObj);
        };
        $scope.model.passwordBlur = function(){
            $scope.model.isWeakPassword = false;
            var pwdObj = utils.getInputObj($scope.model.passwordId);
            if(checkSame(pwdObj)){
                return;
            }
            if (validPassword($scope))
            {
                passwdAsynCheck($scope);
                $scope.model.passwdDtd.done(function() {
                    pwdObj.removeClass('valid_error_input');
                    $scope.model.showPasswordCheck = true;
                    $scope.$apply();
                }).fail(function() {
                    password2error($scope);
                    utils.addErrorTip($scope.model.passwdErr, '#passwordError');
                    $scope.model.showPasswordCheck = false;
                    $scope.$apply();
                });
            }
            else
            {
                password2error($scope);
            }
        }

        function passwdAsynCheck($scope){
            var dtd = $.Deferred();
            iamHttpService.post({
                url: '/authui/passwdAsynCheck',
                params: {
                    domain:$scope.model.domain,
                    username:$scope.model.name,
                    pvvd:$scope.model.password,
                    isCheckByName:'true'
                }
            }).then(function(data){
                if (data.result === true){
                    $scope.model.passwdErr = 'None';
                    utils.removeErrorInfo('#passwordError');
                    dtd.resolve();
                }else{
                    if (data.error_code === '1000'){
                        $scope.model.passwdErr = i18n('invalidInput');
                    }else if (data.error_code === '1001'){
                        $scope.model.passwdErr = i18n('pwdNotUsernameOrInvert');
                    }else if (data.error_code === '1002'){
                        $scope.model.passwdErr = i18n('pwdNotContsMobileOrEmail');
                    }else if (data.error_code === '1003'){
                        $scope.model.isWeakPassword = true;
                        $scope.model.passwdErr = i18n('pwdWeak');
                        $scope.model.lowPasswords.push($scope.model.password);
                        // 会导致JS报错 去掉该设置
                        // iamUtils.setPwdLevelByLevel("strengthLow", "strengthMid", "strengthHigh","low");
                    }else if (data === 'checkVerifyCode4Forbidden'){
                        $scope.model.passwdErr = i18n('freqLocked');
                    }else{
                        $scope.model.passwdErr = i18n('systemException');
                    }
                    dtd.reject();
                }
            },function(){
                $scope.model.passwdErr = i18n('systemException');
                dtd.reject();
            });
            $scope.model.passwdDtd = dtd.promise();
        }

        function password2error($scope) {
            var pwdObj = $('#' + $scope.model.passwordId);//兼容tiny1.48.1和之前的老版本
            if (pwdObj[0].tagName === 'INPUT') {
                pwdObj.addClass('tiny-input-text valid_error_input');
            }else {
                pwdObj.find('input').addClass('tiny-input-text valid_error_input');
            }
        }

        $scope.model.onVerifyTypeClick = function () {
            $('#errorMsg').html('');
            setClearTag();

            if($scope.model.verifyTypeBtn === i18n('resetPwd.byMailbox'))
            {
                $scope.model.verifyTypeBtn = i18n('resetPwd.byPhone');
                $scope.model.verifyTypeLabel = i18n('resetPwd.mailbox');
                $scope.model.msgCodeLabel = i18n('resetPwd.emailMsgCode');
                $scope.model.verifyType = 'email';
                $scope.model.verifyTypeValue = $scope.model.email;
                $scope.model.emailMsgCodeBtnHandler.enableTimer();
                $scope.model.smsMsgCodeBtnHandler.disableTimer($scope.model.msgCode);
                $scope.model.msgCode = '';
                $scope.model.msgCodeValidator = iamUtils.validator.msgCode();

            }
            else
            {
                $scope.model.verifyTypeBtn = i18n('resetPwd.byMailbox');
                $scope.model.verifyTypeLabel = i18n('resetPwd.phone');
                $scope.model.msgCodeLabel = i18n('resetPwd.smsMsgCode');
                $scope.model.verifyType = 'phone';
                $scope.model.verifyTypeValue = $scope.model.phone ? $scope.model.phone.replace(/^0*/, '+').replace(/-/, ' ') : $scope.model.phone;
                $scope.model.smsMsgCodeBtnHandler.enableTimer();
                $scope.model.emailMsgCodeBtnHandler.disableTimer($scope.model.msgCode);
                $scope.model.msgCode = '';
                $scope.model.msgCodeValidator = iamUtils.validator.smsMsgCode();
            }
            $('#verifyCodeMsg').hide();
        };

        var tmer = null;
        function startTimeOut() {

            if (tmer != null) {
                clearTimeout(tmer);
                tmer = null;
            }

            tmer = setTimeout(function() {
                window.history.back(-1);
                clearTimeout(tmer);
                tmer = null;
            }, 30 * 60 * 1000);
        };

        startTimeOut();

        function checkBlack () {
            return [{
                validFn : function (){
                    var value = this.val();
                    if (value == undefined || value.length === 0 ) {
                        return i18n('blankTxt');
                    }
                    return '';
                }
            }];
        };

        $scope.model.equalValidate = iamUtils.validator.confirmPwd('passwordId');
        $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
        $scope.model.requiredValidate = iamUtils.validator.commonValidInput();
        $scope.model.requiredValidate.unshift(iamUtils.validator.notBlank());
        $scope.model.requiredValidate.unshift(iamUtils.validator.childValidator.limitLength(128));

        var oldPasswdValidater = checkBlack();
        oldPasswdValidater.push(iamUtils.validator.maxLen(securityPolicy.passwordpolicy.password_maxlen)[0]);
        oldPasswdValidater.unshift(iamUtils.validator.childValidator.limitLength(33));
        $scope.model.oldPasswdValidate = oldPasswdValidater;

        $scope.model.onMsgCodeBtnClick = function () {

            $('#errorMsg').html('');
            setClearTag();

            if($('#msgBtn').hasClass('msgBtnDisabled'))
            {
                return;
            }

            if ($scope.model.verifyType === 'phone')
            {
                $scope.model.smsMsgCodeBtnHandler.startTimer($scope.model.msgCode);
            }
            else
            {
                $scope.model.emailMsgCodeBtnHandler.startTimer($scope.model.msgCode);
            }

            startTimeOut();

            var url = ($scope.model.verifyType === 'phone') ? '/authui/mobileAuthCode' : '/authui/emailAuthCode';
            $('#verifyCodeMsg').hide();
            iamHttpService.post({
                url: url
            }).then(function (data) {
                if(data.retcode === 200)
                {
                    if(data.remainderCount >= 0) {
                        $scope.model.verifyCodeMsg = data.remainderCount==0? i18n('verifyCode.cantAcquire'):
                            iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#verifyCodeMsg').show();
                    }
                }
                else if (data.retcode === 411)
                {
                    stopMsgCodeHandler($scope);
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'popupMsg');
                }
                else if (data.retcode == 412)
                {
                    stopMsgCodeHandler($scope);
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'popupMsg');
                }
                else if (data.retcode == 410)
                {
                    iamUtils.redirect2Login();
                }
                else
                {
                    stopMsgCodeHandler($scope);
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'popupMsg');
                }
            }, function (data) {
                stopMsgCodeHandler($scope);
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'popupMsg');
            });
        };


        $scope.model.submitKeyPress=function(event){
            iamUtils.enterEvent(event,$scope.onSubmitClick);
        };


        $scope.onSubmitClick = function () {
            if($('#submitBtn').hasClass('btnDisabled'))
            {
                return;
            }
            var oldPwdObj = utils.getInputObj('oldPasswordId');
            if (oldPwdObj.val().length === 0) {
                oldPwdObj.addClass('valid_error_input');
                oldPwdObj.focus();
                return;
            }
            var pwdObj = utils.getInputObj('passwordId');
            if(checkSame(pwdObj)){
                $scope.model.passwordFocused = true;
                return;
            }
            if(!validPassword($scope)){
                pwdObj.addClass('valid_error_input');
                $scope.model.passwordFocused = true;
                return;
            }
            if (pwdObj.val().length === 0) {
                pwdObj.addClass('valid_error_input');
                $scope.model.passwordFocused = true;
                return;
            }

            $('#submitBtn').addClass('btnDisabled');

            if(!iamUtils.unifyValid.FormValid($('#formUl')))
            {
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }
            if(!$scope.model.passwdDtd)
            {
                passwdAsynCheck($scope);
            }
            $scope.model.passwdDtd.fail(function() {
                password2error($scope);
                iamUtils.unifyValid.focusFirst($('#formUl'));
                $('#submitBtn').removeClass('btnDisabled');
                return;
            }).done(function(){
                pwdObj.removeClass('valid_error_input');
                post('/authui/modifyPwd'+window.location.search, {
                    oldimt: $('#' + $scope.model.oldPasswordId).widget().getValue(),
                    newimt: $('#' + $scope.model.passwordId).widget().getValue(),
                    authCode: $scope.model.needValidation ? $('#' + $scope.model.msgCodeId).widget().getValue() : '',
                    pwdLevel: iamUtils.getPwdStrengthLevel($('#' + $scope.model.passwordId).widget().getValue()),
                    verifyType: $scope.model.needValidation ? $scope.model.verifyType : '',
                    Submit:'Login'
                });
                clearSensitiveInfo($scope);
            });
        };

        if($scope.model.isLogout)
        {
            $scope.onCancelClick = function () {
                cancelModify($scope);
                var index = window.location.search.indexOf('actionErrors');
                if(index!= -1)
                {
                    var subsearch = window.location.search.substring(0,index-1);
                    window.location.href = '/authui/'+subsearch;
                }
                else
                {
                    window.location.href = '/authui/'+window.location.search;
                }

            };
        }
        else
        {
            $scope.onCancelClick = function(){
            	var serviceId = iamUtils.getUrlParams()['service'];
            	var bindEmailUrl = iamUtils.getUrlParams()['bindEmailUrl'];
            	if(bindEmailUrl){
            		if(serviceId === undefined){
            			window.location.href = '/authui/remindBindEmail.html?bindEmailUrl=' + encodeURIComponent(bindEmailUrl);
            		}
            		else{
            			window.location.href = '/authui/remindBindEmail.html?service=' + encodeURIComponent(serviceId)
            			                       +'&bindEmailUrl=' + encodeURIComponent(bindEmailUrl);
            		}
            		return;
            	}
                
                if(serviceId === undefined)
                {
                    window.location.href = '/authui/?locale=' + window.language;
                }
                else
                {
                    /*
                     * 1、iamUtils.getUrlParams() 获取url参数值时会做一次url解码
                     * 2、/authui/ 接口在产生ST后，会对service参数做一次url解码，然后将用户重定向到新产生的url
                     * 3、在ICT-O下，两次url解码会导致url中的锚点（ 即：'/#'）暴露，在之后的重定向过程中会锚点信息丢失
                     * 4、为了解决锚点丢失问题，需要此处做url编码
                     * */
                    window.location.href = '/authui/?service=' + encodeURIComponent(serviceId) + '&locale=' + window.language;
                }
            }
        };

        this.getUserInfo($scope, iamHttpService, securityPolicy);

        function checkSame(pwdObj) {
            if($scope.model.oldPassword === $scope.model.password && $scope.model.oldPassword != '')
            {
                $scope.model.passwdErr = $scope.model.pwdSameErrorInfo;
                utils.addErrorTip($scope.model.passwdErr, '#passwordError');
                pwdObj.addClass('tiny-input-text valid_error_input');
                return true;
            }
            else {
                pwdObj.removeClass('valid_error_input');
                utils.removeErrorInfo('#passwordError');
                return false;
            }
        }

        function initPage() {
            if (isApiKeyInit()) {
                return;
            }

            var leftDays = iamUtils.getUrlParams()['leftDays'];
            var isFirstLogin = iamUtils.getUrlParams()['isFirstLogin'];
            $scope.model.isFirstLogin = isFirstLogin === 'true';
            var isPwdExpire = iamUtils.getUrlParams()['isPwdExpire'];

            document.title = i18n('pwdModifyTitle');
            $scope.resetPwdTitle = i18n('pwdModifyTitle');
            $scope.model.pwdSameErrorInfo = i18n('pwdSame');

            if (isFirstLogin) {
                if (isFirstLogin === 'true') {//首次登录
                    document.title = i18n('resetPwd.title');
                    $scope.resetPwdTitle = i18n('resetPwd.title');
                    $scope.titleDetail = i18n('resetPwd.titleDetail');
                    $scope.model.oldPasswdLabel = i18n('resetPwd.InitPasswd');
                    $scope.model.pwdSameErrorInfo = i18n('initialPwdSame');
                }
                else//密码被管理员重置过
                {
                    $scope.titleDetail = i18n('resetPwd.titleDetail');
                }
                return;
            }

            if (isPwdExpire) {
                if (isPwdExpire === 'true') { //密码已经过期
                	document.title = i18n('pwdExpiredTitle');
                    $scope.resetPwdTitle = i18n('pwdExpiredTitle');
                    $scope.titleDetail = i18n('pwdExpiredDesc');
                    $scope.model.oldPasswdLabel = i18n('resetPwd.oldPasswd');
                    $scope.model.pwdSameErrorInfo = i18n('pwdSame');
                }
                return;
            }
            
            if (leftDays) {
                if (leftDays === '0') {//密码过期
                    $scope.titleDetail = i18n('pwdExpiredDesc');
                }
                else {//密码即将到期提醒修改
                    $scope.titleDetail = iamUtils.i18nFormat(i18n('pwdExpiringDesc'), leftDays);
                    $scope.model.isLogout = false;
                }
            }
        }
        function isApiKeyInit() {
            var isApiKey = iamUtils.getUrlParams()['isApiKey'];
            if (isApiKey === 'true') {
                $scope.model.isApiKey = true;
                document.title = i18n('resetPwd.apiKeyTitle');
                $scope.resetPwdTitle = i18n('resetPwd.apiKeyTitle');
                $scope.titleDetail = i18n('resetPwd.apiKeyDetail');
                $scope.model.oldPasswdLabel = i18n('resetPwd.apkKey');
                $scope.model.isLogout = false;
                return true;
            }
            return false;
        }

        function getPasswordPolicy($scope, iamHttpService, securityPolicy) {
            var dtd = $.Deferred();
            iamHttpService.get({
                url: '/rest/authui/welcome/getPassvvdPolicy',
                mask: true
            }).then(function (data) {
                if(data.retinfo === 'success')
                {
                    $scope.model.pwdMinLen = data.pwdMinLen;
                    $scope.model.name = data.name;
                    $scope.model.contSameCharLen = data.contSameCharLen;
                    $scope.model.domain = data.domain;
                    securityPolicy.passwordpolicy.password_minlen = data.pwdMinLen;
                    securityPolicy.passwordpolicy.password_char_combination = data.password_char_combination;

                    $scope.$apply();
                    dtd.resolve();
                } else {
                    iamUtils.redirect2Login();
                    dtd.reject();
                }
            }, function (data) {
                iamUtils.redirect2Login();
                dtd.reject();
            });
            $scope.model.pwdMinLenDtd = dtd.promise();
        }
        
        function validPassword($scope){
            var password = $scope.model.password;
            var isBlank = password.length == 0;
            var minLenResult = password.length >= $scope.model.pwdMinLen && password.length <= 32;
            var containsCharsResult = utils.validatePasswdChar($scope.model.password, securityPolicy.passwordpolicy.password_char_combination);
            var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
            var validatePasswdName =  utils.validatePasswdName(password,$scope.model.name) && utils.validatePasswdNameSHA256(password,$scope.model.name);
            return !isBlank && minLenResult && containsCharsResult && maxSameCharsResult && validatePasswdName;
        }
        function showTip($scope){
            var password = $scope.model.password;
            var isBlank = password.length == 0;
            var minLenResult = password.length >= $scope.model.pwdMinLen && password.length <= 32;
            var containsCharsResult = utils.validatePasswdChar($scope.model.password, securityPolicy.passwordpolicy.password_char_combination);
            var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);
            var validatePasswdName =  utils.validatePasswdName(password,$scope.model.name) && utils.validatePasswdNameSHA256(password,$scope.model.name);
            changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope);
            if(!$scope.model.isWeakPassword  || !minLenResult){
                utils.setPwdLevel4Hws('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', password, i18n, $scope.model.pwdMinLen);
            }
            else
            {
                utils.setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', 'low', i18n);
            }
        }
        function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
            change2ResultEach($scope, 'minLenId', minLenResult);
            change2ResultEach($scope, 'containsCharsId', containsCharsResult);
            change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
            change2ResultEach($scope, 'notNameId', validatePasswdName)
            if (isBlank) {
                $('#containsCharsId').attr('src', $scope.model.validTip);
                $('#minLenId').attr('src', $scope.model.validTip);
                $('#maxSameCharsId').attr('src', $scope.model.validTip);
                $('#notNameId').attr('src', $scope.model.validTip);
            }
        }

        function change2ResultEach($scope, id, result) {
            if (result) {
                $('#' + id).attr('src', $scope.model.validSuc);
            }else {
                $('#' + id).attr('src', $scope.model.validFail);
            }
        }
    };
        
    function setClearTag() {
        var url = '' + window.location;
        if(getSlashSuffix(url)==='resetPwd'){
            window.location = window.location + '?clear=Y';
        }
    }

    function getSlashSuffix(url) {
        var reg = new RegExp('(#/)([^&]*)(&|$)', 'i');
        var r = url.match(reg);
        if (r != null){
            return unescape(r[2]);
        }
        return null;
    };

    function setErrorMsg($scope) {
        var url = '' + window.location
        if (getSlashSuffix(url) === 'resetPwd?clear=Y') return;
        var errorMsgObj = {
            '400': i18n('systemException'),
            '401': i18n('wrongNamePwd'),
            '403': i18n('selfManage.alertTip'),
            '406': i18n('invalidInput'),
            '411': i18n('wrongVerifyCode'),
            '413': i18n('userAccountsLocked'),
            '414': i18n('domainuserAccountsLocked'),
            '415': i18n('userAccountsLocked'),
            '417': i18n('historyPwdSame'),
            '418': dealPwdErrorTips(),
            '419': i18n('noRight'),
            '420': i18n('verifyCode.invalid'),
            '421': i18n('verifyCode.error'),
            '426': i18n('modifyPwdIntervalTimeLessThanMinValidTime')
        };
        if (iamUtils.getUrlParams()['actionErrors']) {
            var status = iamUtils.getUrlParams()['actionErrors'];
            var errCode = parseInt(status);
            if (errCode >= 422 && errCode <= 424) {
                $('#errorMsg').html(iamUtils.i18nFormat(dealPwdMoreErrorTips(), 425 - errCode));
            } else {
                $('#errorMsg').html(errorMsgObj[status]);
            }
        }
        function dealPwdErrorTips() {
            if ($scope.model.isFirstLogin) {
                return i18n('resetPwd.InitPasswdError');
            } else if ($scope.model.isApiKey) {
                return i18n('resetPwd.apiKeyError');
            } else {
                return i18n('resetPwd.resetPwdFailed');
            }
        }
        function dealPwdMoreErrorTips() {
            if ($scope.model.isFirstLogin) {
                return i18n('resetPwd.InitPasswdCount');
            } else if ($scope.model.isApiKey) {
                return i18n('resetPwd.apiKeyErrorCount');
            } else {
                return i18n('resetPwd.resetCount');
            }
        }
    }

    function post(URL, PARAMS) {
        var temp = document.createElement('form');
        temp.action = URL;
        temp.method = 'post';
        temp.style.display = 'none';
        for (var x in PARAMS) {
            var opt = document.createElement('textarea');
            opt.name = x;
            opt.value = PARAMS[x];
            temp.appendChild(opt);
        }
        document.body.appendChild(temp);
        temp.submit();
        return temp;
    }

    function clearSensitiveInfo ($scope) {
        $scope.model.oldPassword = '';
        $scope.model.msgCode = '';
        $scope.model.password = '';
        $scope.model.confirmPassword = '';
    }

    ResetPwd.prototype.msgCodeBtnHandler = function($scope, msgBtnTxt, enable){
        var handler = {
            timeInterval : 60,
            counter: 60,
            enable : enable,
            msgCode : '',
            msgBtnDisable : false,
            msgBtnTxt : msgBtnTxt,
            enableTimer : function (){
                handler.enable = true;
                if (handler.msgBtnDisable)
                {
                    $('#msgBtn').addClass('msgBtnDisabled');
                }
                else
                {
                    $('#msgBtn').removeClass('msgBtnDisabled');
                }

                if (!handler.msgBtnDisable) {
                    $scope.model.msgBtnTxt = handler.msgBtnTxt;
                }
            },
            disableTimer : function (msgCode){
                handler.enable = false;
                if (msgCode != null) {
                    handler.msgCode = msgCode;
                }
            },
            startTimer : function (msgCode){
                handler.counter = 0;
                if (msgCode != null) {
                    handler.msgCode = msgCode;
                }
                setTimeout(count, 0);
            },
            stopTimer : function () {
                handler.counter = handler.timeInterval;
                handler.msgBtnDisable = false;
                $('#msgBtn').removeClass('msgBtnDisabled');
                if (handler.enable) {
                    $scope.model.msgBtnTxt = handler.msgBtnTxt;
                }
                $scope.$apply();
            }
        };

        function count(){
            if (handler.counter < handler.timeInterval){
                handler.counter++;
                if (handler.enable){
                    handler.msgBtnDisable = true;
                    $('#msgBtn').addClass('msgBtnDisabled');
                    $scope.model.msgBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), handler.timeInterval - handler.counter);
                    if(handler.counter != 0)
                    {
                        $scope.$apply();
                    }
                }
                setTimeout(count, 1000);
            }
            else {
                if (handler.enable){
                    handler.stopTimer();
                }
                else {
                    handler.msgBtnDisable = false;
                }
            }
        }
        return handler;
    }

    function stopMsgCodeHandler($scope)
    {
        if ($scope.model.verifyType === 'phone')
        {
            $scope.model.smsMsgCodeBtnHandler.stopTimer();
        }
        else
        {
            $scope.model.emailMsgCodeBtnHandler.stopTimer();
        }
    }

    function cancelModify ($scope) {
        $.ajax('/authui/cancelModifyPwd', {
            async: false,
            cache: false,
            dataType: 'json',
            method: 'POST',
            'headers': {
                'Pragma': 'no-store',
                'Cache-control': 'no-store'
            }
        });
    };

    //个性化定制默认页面初始化，在各个局点的custom中实现该方法
    ResetPwd.prototype.customizedInitResetPage = function($scope, userInfo){}

    ResetPwd.prototype.getUserInfo = function($scope, iamHttpService, securityPolicy) {
        var me = this;
        $scope.model.passwordValidate = [{}];
        iamHttpService.get({
            url: '/authui/getUserInfo',
            mask: true
        }).then(function (data) {
            var retJson = typeof data === 'object' ? data : $.parseJSON(data);
            if(retJson.retinfo === 'success')
            {
                var userInfo = retJson.data;
                var isMobile = iamUtils.isSupportSms && userInfo.mobile;
                $scope.model.verifyTypeValue = isMobile ? iamUtils.SecurityMasker.maskMobile(userInfo.mobile).replace(/^0*/, '+').replace(/-/, ' ') : userInfo.email;
                $scope.model.verifyTypeLabel = isMobile ? i18n('resetPwd.phone') : i18n('resetPwd.mailbox');
                $scope.model.msgCodeLabel = isMobile ? i18n('resetPwd.smsMsgCode') : i18n('resetPwd.emailMsgCode');
                $scope.model.verifyTypeBtn = isMobile ? i18n('resetPwd.byMailbox') : i18n('resetPwd.byPhone');
                $scope.model.emailMsgCodeBtnHandler = isMobile ? me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), false) : me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), true);
                $scope.model.smsMsgCodeBtnHandler =  isMobile ? me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), true) : me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), false);
                $scope.model.verifyType = isMobile? 'phone' : 'email';
                $scope.model.phone = userInfo.mobile ? iamUtils.SecurityMasker.maskMobile(userInfo.mobile) : i18n('emptyStr');
                $scope.model.email = userInfo.email ? userInfo.email : i18n('emptyStr');
                $scope.model.name = userInfo.name;
                $scope.model.domain = userInfo.domain;
                $scope.model.needValidation = retJson.needValidation;


                //法电业务没有绑定邮箱不进行验证码校验
                var productType = window.productType; 

                if (productType == 'OCB' && !userInfo.email) {
                    $scope.model.needValidation = false;
                }
                /*if(!userInfo.email){
                    $scope.model.needValidation = false;
                }*/

                $scope.model.needVerifyTypeBtn = isMobile && userInfo.email ? true : false;
                //me.customizedInitResetPage($scope, userInfo);
                if ($scope.model.verifyType === 'email') {
                    $scope.model.msgBtnTxt = i18n('resetPwd.getEmailMsgCode');
                }
                if(retJson.contSameCharLen && retJson.contSameCharLen != 0)
                {
                    $scope.model.contSameCharLen = retJson.contSameCharLen;
                    $scope.model.maxSameChars = utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'),$scope.model.contSameCharLen);
                }
                else
                {
                    $scope.model.contSameCharLen = 0;
                    $scope.model.maxSameChars = null;
                }
                $scope.model.pwdMinLen = retJson.pwdMinLen ? retJson.pwdMinLen: 6;
                me.setPwdMinLen($scope, securityPolicy, retJson.pwdMinLen, retJson.contSameCharLen);
                $scope.model.isFormShow = true;
                $scope.$apply();
                setErrorMsg($scope);
            }
            else
            {
                me.redirect2Login();
            }

        }, function (data) {
            me.redirect2Login();
        });

    }

    ResetPwd.prototype.setPwdMinLen = function ($scope, securityPolicy, pwdMinLen, numOfRptCharInPwd) {
        var pwdValidator = iamUtils.validator.password(securityPolicy, $scope.model.name, pwdMinLen, numOfRptCharInPwd, $scope.model.oldPasswordId);
        $scope.model.passwordValidate = pwdValidator;
        $scope.model.pwdTip = utils.buildTip(utils.i18nFormat(i18n('minMaxLenTxt'),pwdMinLen, securityPolicy.passwordpolicy.password_maxlen),utils.i18nFormat($scope.model.containsChars, securityPolicy.passwordpolicy.password_char_combination),
            $scope.model.maxSameChars, i18n('pwdNotUsernameOrInvert'), null, i18n);
    }

    ResetPwd.prototype.redirect2Login = function()
    {
        var service = iamUtils.getUrlParams()['service'];
        var language = window.language;
        if (service && language) {
            window.location.href = '/authui/?locale=' + language + '&service=' + encodeURIComponent(iamUtils.getUrlParams()['service']);
        } else if (service && !language) {
            window.location.href = '/authui/?service=' + encodeURIComponent(iamUtils.getUrlParams()['service']);
        } else {
            window.location.href = '/authui/?locale=' + language;
        }
    }
    return ResetPwd;
});



// WEBPACK FOOTER //
// ./public/base/js/resetpwd/controllers/resetPwd.js